export default __webpack_public_path__ + "static/media/Me.bf97d7cd.png";